export default "__VITE_ASSET__Cd9tg0F7__"